// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as CSS$Showside from "../utils/CSS.bs.js";
function Icon(Props) {
  var classNameOpt = Props.className;
  var src = Props.src;
  var alt = Props.alt;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var className$1 = Cn.make([className, CSS$Showside.prefix("object-contain w-full h-full")]);
  return React.createElement("img", {
    className: className$1,
    alt: alt,
    src: src
  });
}
Icon.displayName = "Icon";
var make = React.memo(Icon);
export { make };
/* make Not a pure module */